// Chegada ao jogo: de onde a pessoa veio (?origem=site&cta=...) e para onde ia antes de entrar com Google.
// A origem vai ao GA4 e ao painel no cadastro. O destino é retomado na volta do Google.
import { lerRota, caminhoDa, type Rota } from './rotas.ts';

export interface Origem { origem: string; cta: string | null }

const ORIGEM = 'truco6:origem', DESTINO = 'truco6:destino';
const VALIDO = /^[a-z0-9_-]{1,40}$/;

// Separa origem e cta do resto da query. Valor fora do formato é descartado, mas sai da barra de endereço do mesmo jeito.
export function separarOrigem(busca: string): { origem: Origem | null; resto: string } | null {
  const q = new URLSearchParams(busca);
  if (!q.has('origem') && !q.has('cta')) return null;
  const origem = q.get('origem'), cta = q.get('cta');
  q.delete('origem'); q.delete('cta');
  const resto = q.toString();
  return {
    origem: origem && VALIDO.test(origem) ? { origem, cta: cta && VALIDO.test(cta) ? cta : null } : null,
    resto: resto ? '?' + resto : '',
  };
}

// O destino guardado: o plano escolhido no site vira a tela de assinar, para voltar do Google direto nela.
export function destinoDa(r: Rota): Rota | null {
  switch (r.tela) {
    case 'inicio': case 'sala': case 'indicacao': case 'termos': case 'privacidade': case 'simulado': case 'compra-simulada': return null;
    case 'planos': return r.plano && r.plano !== 'gratis' ? { tela: 'assinar', plano: r.plano, ciclo: r.ciclo } : r;
    default: return r;
  }
}

function guardar(chave: string, valor: string | null): void {
  try { if (valor === null) localStorage.removeItem(chave); else localStorage.setItem(chave, valor); } catch { /* sem armazenamento: segue sem */ }
}
function lerGuardado(chave: string): string | null {
  try { return localStorage.getItem(chave); } catch { return null; }
}

// Lê a origem da URL uma vez, guarda até o cadastro e limpa a barra de endereço.
export function lerOrigemDaUrl(): void {
  const s = separarOrigem(location.search);
  if (!s) return;
  if (s.origem) guardar(ORIGEM, JSON.stringify(s.origem));
  history.replaceState(history.state, '', location.pathname + s.resto + location.hash);
}

// Entrega a origem uma vez só (no cadastro) e apaga.
export function tirarOrigem(): Origem | null {
  const bruto = lerGuardado(ORIGEM);
  guardar(ORIGEM, null);
  try {
    const o = bruto ? (JSON.parse(bruto) as Origem) : null;
    return o && VALIDO.test(o.origem) ? { origem: o.origem, cta: o.cta && VALIDO.test(o.cta) ? o.cta : null } : null;
  } catch { return null; }
}

// Quem já tinha conta: a origem antiga não vale para nada.
export function esquecerOrigem(): void { guardar(ORIGEM, null); }

// O destino vale por 1 hora: dá para ir ao Google e voltar, e não leva ninguém a uma tela velha dias depois.
const VALIDADE_DESTINO_MS = 60 * 60 * 1000;

export function guardarDestino(r: Rota, agora = Date.now()): void {
  const d = destinoDa(r);
  guardar(DESTINO, d ? JSON.stringify({ caminho: caminhoDa(d), em: agora }) : null);
}

export function destinoGuardado(agora = Date.now()): Rota | null {
  try {
    const g = JSON.parse(lerGuardado(DESTINO) ?? 'null') as { caminho: string; em: number } | null;
    if (!g || typeof g.caminho !== 'string' || !(agora - g.em < VALIDADE_DESTINO_MS)) return null;
    const u = new URL(g.caminho, 'https://jogar.trucode6.com.br');
    return destinoDa(lerRota(u.pathname, u.search));
  } catch { return null; }
}

export function tirarDestino(): Rota | null {
  const d = destinoGuardado();
  guardar(DESTINO, null);
  return d;
}
